import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { translate } from '@haldor/ui';
import { getStudentAdditionalAdjustmentsForAssignment } from 'actions/assignments';
import { getStudentAdditionalAdjustmentsForPlan } from 'actions/plans';
import { getStudentAdditionalAdjustmentsForGroup, getStudentAdditionalAdjustmentsForMultipleGroups } from 'actions/sections';
import { Spinner, Person } from 'UI';
import { Block } from '@haldor/ui';
import { GetGroupedByStudent } from '../Helpers';
import AdditionalAdjustmentModal from './AdditionalAdjustmentModal';
import './TeacherAdjustments.scss';

var TeacherAdjustments = /*#__PURE__*/function (_PureComponent) {
  _inherits(TeacherAdjustments, _PureComponent);

  var _super = _createSuper(TeacherAdjustments);

  function TeacherAdjustments(props) {
    var _this;

    _classCallCheck(this, TeacherAdjustments);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.groupId != null) {
        _this.setState({
          loading: true
        });

        _this.props.getStudentAdditionalAdjustmentsForGroup(_this.props.groupId).then(function () {
          _this.setState({
            loading: false
          });
        });
      }

      if (_this.props.assignmentId != null) {
        _this.setState({
          loading: true
        });

        _this.props.getStudentAdditionalAdjustmentsForAssignment(_this.props.assignmentId).then(function () {
          _this.setState({
            loading: false
          });
        });
      }

      if (_this.props.planId != null) {
        _this.setState({
          loading: true
        });

        _this.props.getStudentAdditionalAdjustmentsForPlan(_this.props.planId).then(function () {
          _this.setState({
            loading: false
          });
        });
      }

      if (_this.props.groups != null) {
        _this.setState({
          loading: true
        });

        var promises = [];

        _this.props.groups.forEach(function (groupId) {
          promises.push(_this.getAdjustmentsFromApi(groupId));
        });

        Promise.all(promises).then(function () {
          _this.setState({
            loading: false
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      if (nextProps.groupId != _this.props.groupId) {
        if (nextProps.groupId == null) {
          return false;
        }

        _this.setState({
          loading: true
        });

        if (_this.shouldLoadAdjustments(nextProps.groupId)) {
          _this.props.getStudentAdditionalAdjustmentsForGroup(nextProps.groupId).then(function () {
            _this.setState({
              loading: false
            });
          });
        }
      }

      if (_this.props.groups != null) {
        if (nextProps.groups !== _this.props.groups) {
          _this.setState({
            loading: true
          });

          var promises = [];
          nextProps.groups.forEach(function (groupId) {
            if (_this.shouldLoadAdjustments(groupId)) {
              promises.push(_this.getAdjustmentsFromApi(groupId));
            }
          });
          Promise.all(promises).then(function () {
            _this.setState({
              loading: false
            });
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "shouldLoadAdjustments", function (groupId) {
      return _this.state.loadedGroups.indexOf(groupId) == -1;
    });

    _defineProperty(_assertThisInitialized(_this), "getAdjustmentsFromApi", function (groupId) {
      _this.setState({
        loadedGroups: [].concat(_toConsumableArray(_this.state.loadedGroups), [groupId])
      });

      return _this.props.getStudentAdditionalAdjustmentsForMultipleGroups(groupId);
    });

    _defineProperty(_assertThisInitialized(_this), "getAdjustmentsForGroup", function (groupId) {
      return _toConsumableArray(_this.props.multipleGroupAdjustments).filter(function (adj) {
        return adj.groupId == groupId;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "openAdjustment", function (adjustment) {
      _this.setState({
        activeAdjustment: adjustment.id
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeAdjustment", function () {
      _this.setState({
        activeAdjustment: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "adjustmentInUse", function (additionalAdjustment) {
      var inUse = false;
      additionalAdjustment.items.forEach(function (student) {
        student.items.forEach(function (adjustment) {
          if (adjustment.status == 'ACTIVE') {
            inUse = true;
          }
        });
      });
      return inUse;
    });

    _this.state = {
      activeAdjustment: null,
      loading: false,
      loadedGroups: []
    };
    return _this;
  }
  /* Lifecycle methods - JLIFE */


  _createClass(TeacherAdjustments, [{
    key: "render",
    value:
    /* Render methods - JREND */
    function render() {
      var _this2 = this;

      if (this.state.loading) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }

      var adjustments = [];
      var activeAdjustment = null;

      if (this.props.groups != null) {
        this.props.groups.forEach(function (groupId) {
          adjustments = [].concat(_toConsumableArray(adjustments), _toConsumableArray(_this2.getAdjustmentsForGroup(groupId)));
        });
      } else if (this.props.assignmentId) {
        adjustments = this.props.assignment;
      } else if (this.props.planId) {
        adjustments = this.props.plan;
      } else {
        if (this.props.adjustments != null) {
          adjustments = this.props.adjustments;
        } else {
          adjustments = this.props.groupAdjustments;
        }
      }

      var groupedBy = GetGroupedByStudent(adjustments, null, this.props.subjects);

      if (groupedBy.length == 0) {
        return /*#__PURE__*/React.createElement("div", {
          className: "teacher-adjustments"
        }, /*#__PURE__*/React.createElement("div", {
          className: "text--center color--meta",
          style: {
            margin: '1rem 0'
          }
        }, this.props.translate('no-results')));
      }

      if (this.state.activeAdjustment != null) {
        activeAdjustment = groupedBy.find(function (gb) {
          return gb.id == _this2.state.activeAdjustment;
        });

        if (activeAdjustment != null) {
          var hasActive = activeAdjustment.items.find(function (student) {
            return student.items.find(function (adjustment) {
              return adjustment.status == "ACTIVE";
            });
          });

          if (hasActive == null) {
            activeAdjustment = null;
          }
        }
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "teacher-adjustments"
      }, /*#__PURE__*/React.createElement(AdditionalAdjustmentModal, {
        onClose: this.closeAdjustment,
        adjustment: activeAdjustment,
        disableCommenting: this.props.disableCommenting
      }), /*#__PURE__*/React.createElement("div", {
        className: "adjustments"
      }, groupedBy.map(function (additionalAdjustment) {
        var additionalAdjustmentInUse = _this2.adjustmentInUse(additionalAdjustment);

        if (additionalAdjustmentInUse) {
          return /*#__PURE__*/React.createElement("div", {
            className: "grid-item",
            key: additionalAdjustment.id,
            onClick: function onClick() {
              return _this2.openAdjustment(additionalAdjustment);
            }
          }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("span", {
            className: "title"
          }, additionalAdjustment.title, additionalAdjustment.subTitle != null ? ' - ' + additionalAdjustment.subTitle : null), /*#__PURE__*/React.createElement("div", {
            className: "students"
          }, additionalAdjustment.items.map(function (student) {
            var activeItems = student.items.find(function (adjustment) {
              return adjustment.status == 'ACTIVE';
            });

            if (activeItems == null) {
              return null;
            }

            return /*#__PURE__*/React.createElement(Person, {
              person: student,
              key: student.userId
            });
          }))));
        } else {
          return null;
        }
      })));
    }
  }]);

  return TeacherAdjustments;
}(PureComponent);

_defineProperty(TeacherAdjustments, "defaultProps", {
  hideAll: false,
  disableCommenting: false
});

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    groupAdjustments: state.AdditionalAdjustments.groupAdjustments,
    multipleGroupAdjustments: state.AdditionalAdjustments.multipleGroupAdjustments,
    assignment: state.AdditionalAdjustments.assignment,
    plan: state.AdditionalAdjustments.plan
  };
}

export default connect(mapStateToProps, {
  getStudentAdditionalAdjustmentsForAssignment: getStudentAdditionalAdjustmentsForAssignment,
  getStudentAdditionalAdjustmentsForPlan: getStudentAdditionalAdjustmentsForPlan,
  getStudentAdditionalAdjustmentsForGroup: getStudentAdditionalAdjustmentsForGroup,
  getStudentAdditionalAdjustmentsForMultipleGroups: getStudentAdditionalAdjustmentsForMultipleGroups
})(TeacherAdjustments);